import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import {TextField} from "@mui/material";
import React from "react";

export function Form_DateTime(props) {
    const {item, localFormState, setLocalFormState} = props;
    const { inputSize = "normal" } = item;

    React.useEffect(() => {
        if (localFormState[item.key] === null || localFormState[item.key] === undefined) {
            localFormState[item.key] = new Date();
        }
    }, []);


    return (<>
        <DateTimePicker
            sx={{background:'red'}}
            renderInput={(props) => <TextField variant="outlined" required={item.required || false} className={"w-100"} {...props} />}
            label={item.label}
            // className={"w-100"}
            helperText={item.helperText}
            variant="contained"
            size={inputSize}
            disabled={ item.disabled === undefined ? false : item.disabled }
            value={(localFormState[item.key] === null || localFormState[item.key] === undefined) ? new Date() : localFormState[item.key]}
            onChange={
                (val) => {
                    setLocalFormState({
                        ...localFormState,
                        [item.key]: val
                    });
                }
            }
        />
    </>);
}